import { Image } from '~/components/Image';
import Text from '~/components/Text';

interface Props {
  message: string;
  children?: React.ReactNode;
  logo?: string;
  logoAlt: string;
}

const FormSubmissionMessage = ({ message, children, logo, logoAlt }: Props) => {
  return (
    <div className="flex flex-col items-center space-y-8 pt-16">
      <div className="h-24 w-24 overflow-hidden rounded shadow-md">
        {logo && <Image src={logo} alt={logoAlt} maxWidth={200} aspectRatio="square" />}
      </div>
      <Text as="h6" size={'2xl'} weight="semibold" type="title" theme="default" className="max-w-md text-center">
        {message}
      </Text>
      <div>{children}</div>
    </div>
  );
};

export default FormSubmissionMessage;
